<template>
    <div class="flex items-center justify-center space-x-2 mb-4">
        <PictureAvatarUser :user="user" :currentPicture="currentPicture" />
    </div>
     <ul class="flex flex-col space-y-4">
        <li class="text-sm w-full flex justify-between py-3 border-b border-gray-200 font-bold">
            <div class="flex items-center">
                <i class="fad fa-user text-sm mr-1"></i>
                <span class="underline">Nom & prénom(s):</span>
            </div>
            <span class="text-sky">{{ user.name }}</span>
        </li>
        <li class="text-sm w-full flex justify-between py-3 border-b border-gray-200 font-bold">
            <div class="flex items-center">
                <i class="fad fa-envelope text-sm mr-1"></i>
                <span class="underline">Email:</span>
            </div>
            <span class="text-sky">{{ user.email ? user.email : 'Non renseigné' }}</span>
        </li>
        <li class="text-sm w-full flex justify-between py-3 border-b border-gray-200 font-bold">
            <div class="flex items-center">
                <i class="fad fa-phone text-sm mr-1"></i>
                <span class="underline">Téléphone:</span>
            </div>
            <span class="text-sky">{{ user.full_phone }}</span>
        </li>
        <li class="text-sm w-full flex justify-between font-bold">
            <div class="flex items-center">
                <i class="fad fa-shield text-sm mr-1"></i>
                <span class="underline">Rôle:</span>
            </div>
            <StatusBadge class="capitalize" :label="user.role_real_text" :color="user.role_real_color" />
        </li>
    </ul>
</template>

<script>
    import StatusBadge from '@/Components/StatusBadge'
    import PictureAvatarUser from '@/Components/PictureAvatarUser'

    export default {
        components: {
            StatusBadge,
            PictureAvatarUser
        },

        props: {
            user: Object
        }
    }
</script>
